import {
  LOAD_TAX_PARAMETERS,
  TAX_PARAMETERS_LOADED,
  SAVE_TAX_PARAMETER,
  TAX_PARAMETER_SAVED,
  TAX_PARAMETER_DELETED,
  RESET_TAX_PARAMETERS,
  RESET_SEARCH_TAX_PARAMETERS,
  SYNC_FAILED,
} from './actionTypes';
import { ITaxParameter } from './types';

export const initialState = {
  error: null,
  taxParametersLoaded: false,
  taxParameters: [],
  taxParameterSaved: false,
  taxParameterSyncing: false,
  syncing: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_TAX_PARAMETERS:
      return { ...state, error: null, syncing: true };
    case TAX_PARAMETERS_LOADED:
      return {
        ...state,
        error: null,
        taxParameters: action.payload,
        syncing: false,
        taxParametersLoaded: true,
      };
    case SAVE_TAX_PARAMETER:
      return {
        ...state,
        error: null,
        taxParameterSaved: false,
        taxParameterSyncing: true,
      };
    case TAX_PARAMETER_SAVED:
      let isUpdate = false;
      const taxParams = state.taxParameters.map((item: any) => {
        if (item.enterpriseUnit === action.payload.enterpriseUnit) {
          isUpdate = true;
          return {
            enterpriseUnit: action.payload.enterpriseUnit,
            configuration: { ...action.payload },
          };
        }

        return item;
      });

      if (!isUpdate) {
        taxParams.push({
          enterpriseUnit: action.payload.enterpriseUnit,
          configuration: { ...action.payload },
        });
      }

      return {
        ...state,
        taxParameterSaved: !state.taxParameterSaved,
        taxParameterSyncing: false,
        taxParameters: taxParams,
      };
    case TAX_PARAMETER_DELETED:
      const newTaxParameters = state.taxParameters.filter((item: ITaxParameter) => {
        return item.enterpriseUnit !== action.payload;
      });

      return { ...state, taxParameters: newTaxParameters };
    case RESET_TAX_PARAMETERS:
      return initialState;
    case RESET_SEARCH_TAX_PARAMETERS:
      return { ...state, searchTaxParametersLoaded: false, searchTaxParameters: [] };
    case SYNC_FAILED:
      return { ...state, syncing: false, taxParameterSyncing: false, error: action.payload };
    default:
      return state;
  }
};
